// extracted by mini-css-extract-plugin
export default {"TabsContainer":"Tabs_TabsContainer__DAbJ3","tab":"Tabs_tab__n4e7t","tabSelected":"Tabs_tabSelected__SP7-y","counts":"Tabs_counts__fWB-O"};